function WrapperDisplay({ display, children }) {
  return display && children;
}

export default WrapperDisplay;
